<template>
    <div class="c-middle" style="padding: 12px">
        <div class="c-middle-map">
            <div class="c-middle-grid-name">{{ hezhangInfo.name }}</div>
            <MapContainer ref="mapRef" :showZoomTool="false" :showBottom="false" :center="mapConfig.positionVal"
                :zoom="16" :maxZoom="20" :minZoom="14">
                <template slot="openlayer">
                    <!-- 湖岛项目，照片图层 -->
                    <OpenlayerHeZhangLayer :hzList="hezhangList" :positionFitVal="mapConfig.positionFitVal"
                        :photoList="photoList" :eventList="eventList" :activityObj="activityObj"></OpenlayerHeZhangLayer>

                </template>
            </MapContainer>
            <!-- 底部时间轴 -->
            <SelectYear style="bottom: 40px" :selectTime="selectTime" @changeSelectTime="bindSelectTime">
            </SelectYear>
        </div>
    </div>
</template>

<script>
import MapContainer from '@/components/map/MapContainer/MapContainer.vue';
import SelectYear from '@/page/business/components/SelectYear/SelectYear.vue';
import OpenlayerHeZhangLayer from '@/page/business/hezhang/components/OpenlayerHeZhangLayer.vue';

export default {
    components: {
        MapContainer,
        SelectYear,
        OpenlayerHeZhangLayer,
        // EventPoints,
    },
    props: {
        // 时间范围数组
        queryDate: {
            // eslint-disable-next-line no-bitwise
            type: Array,

            default () {
                return [];
            },
        },
        // 河长列表数据
        hezhangList: {
            type: Array,
            default () {
                return [];
            },
        },
        hezhangInfo: {
            type: Object,
            default () {
                return {};
            },
        },
        photoList: {
            type: Array,
            default: () => [],
        },
        // 事件列表数据
        eventList: {
            type: Array,
            default () {
                return [];
            },
        },
        mapConfig: {
            typeof: Object,
            default () {
                return {
                    positionFitVal: [],
                    positionVal: [],
                    mapRange: 0.0008,
                };
            },
        },
        activityObj: {
            type: Object,
            default () {
                return {};
            },
        },
    },

    data () {
        // 计算当前日期的前一个月
        const getPrevMonth = () => {
            const now = new Date();
            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth() + 1; // 当前月份（1-12）

            // 计算前一个月的年和月
            let prevYear;
            let prevMonth;
            if (currentMonth === 1) {
                // 若当前是1月，前一个月是去年12月
                prevYear = currentYear - 1;
                prevMonth = 12;
            } else {
                prevYear = currentYear;
                prevMonth = currentMonth - 1;
            }

            // 转换为selectLeftActiveMonth格式：(年份-2021)*12 + 月份

            return prevMonth;
        };
        return {
            imgModel: '1',
            activityTab: '',
            routeObj: {}, // 路由对象，用于获取当前路由的参数
            photoShow: false,
            // 历史图片列表数据
            historyImgList: [],
            gridWaypoint: '',
            searchForm: {
                queryDate: [],
            },
            positionFitVal: [],
            // 默认选中时间对象
            selectTime: {
                year: new Date().getFullYear(),
                yearLeft: new Date().getFullYear(),
                yearRight: new Date().getFullYear(),
                monthLeft: getPrevMonth(), // 默认今年1月
                monthRight: new Date().getMonth() + 1,
                dayLeft: new Date().getDate(),
                dayRight: new Date().getDate(),
            },

        };
    },
    watch: {
        activityObj: {
            handler (newVal) {
                this.$refs.mapRef && this.$refs.mapRef.toMapZoom(18);
            },
            immediate: true,
            deep: true,
        },
        queryDate: {
            handler (newVal) {
                if (newVal) {
                    this.selectTime = newVal;
                }
            },
            immediate: true,
            deep: true,
        },
        photoShow: {
            handler (newVal) {
                let mapRange = newVal ? 0.002 : 0.0008;
                let geometryText = this.hezhangInfo.geometryText;
                this.$emit('getPositionFitVal', geometryText, mapRange);
            },
            deep: true,
        },
        imgModel: {
            handler (newVal) {
                if (newVal !== '1') {
                    this.searchForm = {
                        queryDate: [],

                    };
                }
            },
            immediate: true,
            deep: true,
        },
        searchForm: {
            handler (newVal) {
                this.$emit('changeSelectTime', newVal.queryDate);
            },
            deep: true,
        },
        photoInfo: {
            handler (newVal) {
            },
            immediate: true,
            deep: true,
        },
        mapConfig: {
            handler (newVal) {
                if (newVal.positionVal.length > 0) {
                    this.toMapCenter(newVal.positionVal);
                }
            },
            immediate: true,
            deep: true,
        },
    },
    created () {

    },
    computed: {},
    mounted () { },
    methods: {

        /**
         * 将地图中心点移动到指定位置
         *
         * @param center 地图中心点坐标，格式为 [经度, 纬度]
         */
        toMapCenter(center) {
            if (this.$refs.mapRef) {
                this.$refs.mapRef.toCenter(center);
            }
        },

        // 时间选择回调函数
        bindSelectTime (type, time) {
            // console.log('bindSelectTime', type, time);

            if (type === 'year') {
                this.selectTime.year = time;
            }
            if (type === 'times') {
                Object.assign(this.selectTime, time.Lefttimes, time.Righttimes);
            }
            this.searchForm.queryDate = [
                `${this.selectTime.yearLeft}-${this.selectTime.monthLeft}-${this.selectTime.dayLeft} 00:00:00`,
                `${this.selectTime.yearRight}-${this.selectTime.monthRight}-${this.selectTime.dayRight} 23:59:59`,
            ];
        },

    },
    provide () {
        return {
            selectTime: this.selectTime, // 可传递响应式数据
            searchForm: this.searchForm, // 可传递响应式数据
        };
    },
};
</script>

<style lang="scss" scoped>
.c-middle {
    width: 100%;
    height: 100%;
    display: flex;

    .c-middle-map {
        flex: 1;
        height: 100%;
        position: relative;

        .c-middle-grid-name {
            position: absolute;
            top: 10px;
            left: 50%;
            margin-left: -150px;

            width: 240px;
            height: 40px;
            line-height: 40px;
            background: rgba(0, 0, 0, 0.65);
            border-radius: 2px 2px 2px 2px;
            text-align: center;
            z-index: 9;
        }
    }

    .c-middle-right {
        height: 100%;
        margin-left: 8px;
        padding: 0px;
        position: relative;

        .img-centre-bottom {
            position: absolute;
            bottom: 60px;

            width: 90px;
            height: 34px;
            text-align: center;
            line-height: 30px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 304px 304px 304px 304px;
            z-index: 100;
        }

        .img-centre-top {
            height: 30px;
            line-height: 30px;
            background: rgba(7, 17, 80, 0.7);
            z-index: 99;
            display: flex;
            position: absolute;

            div {
                padding: 0 8px;
            }
        }

        .right-item {
            height: calc(100%);
            width: 100%;
        }
    }
}

.activity-model {
    color: #49f0fdff;
}

.link-disabled {
    color: gray;
    cursor: not-allowed;
    pointer-events: none;
}

.width-25 {
    width: calc(100% - 250px);
}

.width-100 {
    width: 100%;
}

.center-1 {
    left: 415px;
}

.center-2 {
    left: 50%;
    margin-left: -45px;
}
</style>
